import React from 'react';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';

import ReactTable from 'react-table';
import { Row, Col } from 'reactstrap';
import { PlusCircleOutlined } from '@ant-design/icons';

import { Menu, Tabs, Button } from 'antd';
import Tour from 'reactour';

import IHelpButton from '../../components/primitives/IHelpButton'
// // Local Deps
import Loading from '../../components/Loading';
import history from '../../config/history';

import './ContractCenter.scss';

import ContractCenterHOC from './ContractCenterHOC';

const { TabPane } = Tabs;
class ContractCenter extends React.Component {
  static propTypes = {
    activeData: PropTypes.array.isRequired,
    activeMenu: PropTypes.string.isRequired,
    activeTab: PropTypes.string.isRequired,
    changeTab: PropTypes.func.isRequired,
    changeMenu: PropTypes.func.isRequired,
    columns: PropTypes.array.isRequired,
    // rfqHits: PropTypes.number.isRequired,
    // quoteHits: PropTypes.number.isRequired,
    createRFQ: PropTypes.func.isRequired,
    isTourOpen: PropTypes.bool.isRequired,
    openTour: PropTypes.func.isRequired,
    closeTour: PropTypes.func.isRequired,
  };

  // static defaultProps = {

  // };

  render() {
    const {
      activeData,
      // rfqHits,
      // quoteHits,
      activeMenu,
      activeTab,
      changeTab,
      changeMenu,
      columns,
      createRFQ,
      isTourOpen,
      openTour,
      closeTour,
    } = this.props;

    return (
      <div className="nf-account-admin">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Contract Center</title>
          <meta name="description" content="description1" />
          <meta name="keywords" content="keyword1,keyword2,keyword3" />
        </Helmet>


        <Row className="nf-account-admin__header">
          <Col xs="1" />

          <Col>
            <IHelpButton />
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
              <h1>Request for Quote (RFQ) Management</h1>
              <Button
                style={{ marginLeft: '16px', marginBottom: ' 20px' }}
                type="primary"
                ghost
                onClick={openTour}
              >
                Tour
              </Button>
            </div>
          </Col>
        </Row>


        {(!columns[0] || !activeData) && <Loading />}
        {columns[0] &&
          activeData && (
            <Row className="message-center-body">
              <Col xs="2" className="message-center-sidemenu">
                <Menu
                  data-tut="reactour__menu"
                  mode="inline"
                  // inlineCollapsed={this.state.collapsed}
                  onClick={changeMenu}
                  selectedKeys={[activeMenu]}
                >
                  <Menu.Item data-tut="reactour__submenu-rfq" key="rfq">
                    Sent RFQs
                  </Menu.Item>
                  <Menu.Item key="quotes" data-tut="reactour__submenu-quote">
                    Received RFQs
                  </Menu.Item>
                  <Menu.Item style={{ 'display': 'none' }} key="dibbs">Dibbs Quotes</Menu.Item>
                </Menu>
              </Col>
              <Col className="message-center-table">
                <div className="message-center-table-header">
                  <Tabs
                    activeKey={activeTab}
                    data-tut="reactour__tabs"
                    type="card"
                    className="tabs1-wrapper"
                    onChange={changeTab}
                  >
                    {activeMenu === 'rfq' && (
                      <TabPane tab="Drafts" key="drafts" />
                    )}

                    {activeMenu === 'quotes' && (
                      <TabPane tab="Requests" key="requested" />
                    )}
                    <TabPane tab="Submitted" key="submitted" />
                    {activeMenu === 'rfq' && (
                      <TabPane tab="Ready for Review" key="rfr" />
                    )}
                    {activeMenu === 'dibbs' && (
                      <TabPane tab="Created" key="created" />
                    )}
                    <TabPane tab="Awarded" key="awarded" />
                    <TabPane tab="Archived" key="archived" />
                  </Tabs>
                  <Button onClick={createRFQ} data-tut="reactour__new-rfq">
                    <PlusCircleOutlined /> New RFQ
                  </Button>
                </div>
                <div
                  className="nf-contractcenter-grid"
                  data-tut="reactour__table"
                >
                  <ReactTable
                    columns={columns}
                    data={activeData}
                    defaultSorted={[
                      {
                        id: 'modified',
                        desc: true,
                      },
                    ]}
                    showPageSizeOptions={false}
                    getTdProps={(_, rowInfo, column) => {
                      console.log('tdprops');
                      return {
                        onClick: () => {
                          console.log(rowInfo, column);
                          if (column.Header) {
                            if (!rowInfo) {
                              return;
                            }
                            if (
                              rowInfo.original.quoteId &&
                              rowInfo.original.rfqId
                            ) {
                              history.push(
                                `/contractcenter/quote?quote=${rowInfo.original.quoteId
                                }&rfq=${rowInfo.original.rfqId}`,
                              );
                            } else if (rowInfo.original.dqCreateDate) {
                              history.push(
                                `/contractcenter/dibbs?solNum=${rowInfo.original.solNum
                                }`,
                              );
                            } else {
                              history.push(
                                `/contractcenter/rfq?rfq=${rowInfo.original.rfqId
                                }`,
                              );
                            }
                          }
                        },
                      };
                    }}
                  />
                </div>
              </Col>
            </Row>
          )}

        <Tour
          onRequestClose={closeTour}
          steps={tourConfig}
          disableInteraction
          isOpen={isTourOpen}
          maskClassName="mask"
          className="helper"
          rounded={5}
          accentColor={accentColor}
        />
      </div>
    );
  }
}
const tourConfig = [
  {
    content: `Welcome to the RFQ Management Center. The RFQ Management Center allows you to create and send Requests for Quote (RFQs) to other companies in ICON and to respond to RFQs received from other companies in ICON.`,
  },

  // {
  //   selector: '[data-tut="reactour__table"]',
  //   content: ` The grid view shows relevant information for RFQs you have sent and RFQs you have received. RFQs are organized into tabs based on their current status.`,
  // },
  {
    selector: '[data-tut="reactour__menu"]',
    content: `Switch between Sent RFQs (RFQs sent byyour organization) and Received RFQs (RFQs received by your organization).`,
  },
  {
    selector: '[data-tut="reactour__submenu-rfq"]',
    content: `The Sent RFQs folder is where you (1) create, manage, and send RFQs to other companies in ICON, and (2) view and approve quotes received back from recipient companies.`,
  },
  {
    selector: '[data-tut="reactour__submenu-quote"]',
    content: `The Received RFQs folder allows you to viewand respond to RFQs received from other companies in ICON.`,
  },
  {
    selector: '[data-tut="reactour__tabs"]',
    content: `RFQs are organized under tabs based ontheir current status (Draft, Submitted, Awarded, and Archived for Sent RFQs and Requested, Submitted, Awarded, and Archived for Received RFQs).`,
  },
  {
    selector: '[data-tut="reactour__new-rfq"]',
    content: `The New RFQ button allows you to create a new RFQ and select recipients to which to send the RFQ.`,
  },

  {
    selector: '[data-tut="reactour__help"]',
    content: `View additional information and help (including FAQs) about RFQ Management topics.`,
  },
];
const accentColor = '#ff7c52';

export default ContractCenterHOC(ContractCenter);



// WEBPACK FOOTER //
// ./src/pages/ContractCenter/ContractCenter.jsx